export default import.meta.ROLLDOWN_FILE_URL_mdfQ0EQSrVJVp3yHbBUGNA